export default __webpack_public_path__ + "static/media/fa-solid-900.fc5dd5b7.svg";